export default () => {
  return [
    {
      path: '',
      name: 'root',
      redirect: 'main',
      component: () => System.import('./views/index.vue'),
      children: [
        {
          path: '/main',
          name: 'main',
          meta: {
            auth: true,
            enter_id: 'edmodolabs_web_homepage001001',
            leave_id: 'edmodolabs_web_homepage001007'
          },
          component: () => System.import('./main/views/index.vue')
        },
        {
          path: 'edo_app/:product_id',
          name: 'edo_app',
          meta: {
            auth: true,
            enter_id: 'edmodolabs_web_detail001001',
            leave_id: 'edmodolabs_web_detail001009'
          },
          component: () => System.import('./lesson/views/index.vue')
        },
        {
          path: 'edo_app/appOperation/:appId',
          name: 'app-operation',
          meta: {
            auth: true
          },
          component: () => System.import('./lesson/views/appOperation.vue')
        },
        {
          path: 'third-login',
          name: 'third-login',
          meta: {
            auth: true
          },
          component: () => System.import('./login/index.vue')
        },
        {
          path: 'edo_product',
          name: 'edo_product',
          meta: {
            auth: true
          },
          component: () => System.import('./productList/productList.vue')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/modules/home/create-routes.js